import React from 'react';
import './MobileNav.css';

/**
 * Mobile Navigation Component
 * Provides bottom navigation bar for mobile devices with 5 actions:
 * - Plan: Start new chat in plan mode
 * - Agent: Start new chat in agent mode
 * - New (center): Start new chat keeping current mode
 * - Code: Access AI Coder features
 * - Preview: Show preview
 * 
 * @param {Object} props
 * @param {Function} props.onNewChatPlan - Callback to start new chat in plan mode
 * @param {Function} props.onNewChatAgent - Callback to start new chat in agent mode
 * @param {Function} props.onNewChat - Callback to start new chat keeping current mode
 * @param {Function} props.onOpenCode - Callback to open AI Coder
 * @param {Function} props.onOpenPreview - Callback to open preview
 * @param {string} props.activeMode - Current active mode ('plan' or 'agent')
 * @param {string} props.activeView - Current active view ('chat', 'code', 'preview')
 */
function MobileNav({ 
  onNewChatPlan,
  onNewChatAgent,
  onNewChat,
  onOpenCode,
  onOpenPreview,
  activeMode = 'agent',
  activeView = 'chat'
}) {

  return (
    <nav className="mobile-nav" role="navigation" aria-label="Mobile navigation">
      {/* Plan Mode - New chat in plan mode */}
      <button
        className={`mobile-nav-item ${activeMode === 'plan' ? 'active' : ''}`}
        onClick={onNewChatPlan}
        type="button"
        aria-label="New chat in Plan mode"
      >
        <span className="mobile-nav-icon">📋</span>
        <span className="mobile-nav-label">Plan</span>
      </button>

      {/* Agent Mode - New chat in agent mode */}
      <button
        className={`mobile-nav-item ${activeMode === 'agent' ? 'active' : ''}`}
        onClick={onNewChatAgent}
        type="button"
        aria-label="New chat in Agent mode"
      >
        <span className="mobile-nav-icon">🤖</span>
        <span className="mobile-nav-label">Agent</span>
      </button>

      {/* New Chat (center) - Keep current mode */}
      <button
        className="mobile-nav-item mobile-nav-new"
        onClick={onNewChat}
        type="button"
        aria-label="New chat"
      >
        <div className="mobile-nav-new-button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path 
              d="M12 5v14M5 12h14" 
              stroke="white" 
              strokeWidth="2.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <span className="mobile-nav-label">New</span>
      </button>

      {/* Code - Access AI Coder features */}
      <button
        className={`mobile-nav-item ${activeView === 'code' ? 'active' : ''}`}
        onClick={onOpenCode}
        type="button"
        aria-label="AI Coder"
      >
        <span className="mobile-nav-icon">💻</span>
        <span className="mobile-nav-label">Code</span>
      </button>

      {/* Preview - Show preview */}
      <button
        className={`mobile-nav-item ${activeView === 'preview' ? 'active' : ''}`}
        onClick={onOpenPreview}
        type="button"
        aria-label="Preview"
      >
        <span className="mobile-nav-icon">👁️</span>
        <span className="mobile-nav-label">Preview</span>
      </button>
    </nav>
  );
}

export default MobileNav;
